const MainURL = 'https://churchappmore.com';

export default MainURL;